define('services/avatarService',["require", "exports", "models/account", "services/settings", "common/constants"], function (require, exports, Account, Configuration, constants_1) {
    "use strict";
    var AvatarService = (function () {
        function AvatarService() {
        }
        AvatarService.downloadAvatar = function (userId) {
            var _this = this;
            var defer = $.Deferred();
            var request = new XMLHttpRequest();
            request.open("GET", AvatarService.getAvatarUrl(userId), true);
            request.setRequestHeader('Authorization', Account.Session.getAuthorizationHeader());
            request.responseType = "blob";
            request.onload = function () {
                var reader = new FileReader();
                var blob = request.response;
                if (blob.size === 0) {
                    defer.resolve(_this.getDefaultAvatar());
                }
                else {
                    reader.readAsDataURL(blob);
                    reader.onloadend = function () {
                        defer.resolve(reader.result);
                    };
                }
            };
            request.send();
            return defer.promise();
        };
        AvatarService.getDefaultAvatar = function () {
            return constants_1.DEFAULT_AVATAR_PATH;
        };
        AvatarService.getAvatarUrl = function (userId) {
            return Configuration.Settings.getServiceFor("OneClick", "api/configuration/useridentities/", userId + "/images/avatar");
        };
        return AvatarService;
    }());
    exports.AvatarService = AvatarService;
});

